import React, { useEffect } from 'react';
import HomeArt from './pages/HomeArt';
import HomeLinktree from './pages/HomeLinktree';
import SongRedirect from './pages/SongRedirect';
import { getLandingVariant } from './utils/landingVariant';
import songLinks from './data/songLinks';

const isListenPage = window.location.pathname.replace(/\/+$/, '') === '/listen';
const songSlug = isListenPage ? new URLSearchParams(window.location.search).get('song') : null;
const songLink = songSlug ? songLinks[songSlug] : undefined;
const hasSongRedirect = Boolean(songLink?.spotify);

function App(): JSX.Element {
  const variant = getLandingVariant(isListenPage);

  useEffect(() => {
    if (!isListenPage || hasSongRedirect) return;
    fbq('trackCustom', 'LandingVariantView', { variant });
    gtag('event', 'landing_variant_view', { variant });
  }, [variant]);

  if (hasSongRedirect) {
    return <SongRedirect slug={songSlug as string} url={(songLink as { spotify: string }).spotify} />;
  }

  if (variant === 'linktree') {
    return <HomeLinktree variant={variant} />;
  }

  return <HomeArt variant={variant} />;
}

export default App;
